export const names = [
    {
        "name": "Darin Hinton",
        "gender": "male"
    },
    {
        "name": "Rolando Calhoun",
        "gender": "male"
    },
    {
        "name": "Nicolas Saunders",
        "gender": "male"
    },
    {
        "name": "Sam Berg",
        "gender": "male"
    },
    {
        "name": "Randolph Donaldson",
        "gender": "male"
    },
    {
        "name": "Dylan Ochoa",
        "gender": "male"
    },
    {
        "name": "Gregorio Bowman",
        "gender": "male"
    },
    {
        "name": "Dean Stein",
        "gender": "male"
    },
    {
        "name": "Elwood Aguirre",
        "gender": "male"
    },
    {
        "name": "Preston Williams",
        "gender": "male"
    },
    {
        "name": "Federico Campbell",
        "gender": "male"
    },
    {
        "name": "Brendan Robertson",
        "gender": "male"
    },
    {
        "name": "Leif Blair",
        "gender": "male"
    },
    {
        "name": "Maximo Bean",
        "gender": "male"
    },
    {
        "name": "Rodrick Bryant",
        "gender": "male"
    },
    {
        "name": "Johnny Wiggins",
        "gender": "male"
    },
    {
        "name": "Marion Brooks",
        "gender": "male"
    },
    {
        "name": "Carter Wilkinson",
        "gender": "male"
    },
    {
        "name": "Danial Collins",
        "gender": "male"
    },
    {
        "name": "Ian Wade",
        "gender": "male"
    },
    {
        "name": "Dominick Jacobs",
        "gender": "male"
    },
    {
        "name": "Wesley Conrad",
        "gender": "male"
    },
    {
        "name": "Myron Lawrence",
        "gender": "male"
    },
    {
        "name": "Avery Daniel",
        "gender": "male"
    },
    {
        "name": "Refugio Davila",
        "gender": "male"
    },
    {
        "name": "Boyd Villa",
        "gender": "male"
    },
    {
        "name": "Keneth Ellis",
        "gender": "male"
    },
    {
        "name": "Chi Sampson",
        "gender": "male"
    },
    {
        "name": "Stuart Fitzpatrick",
        "gender": "male"
    },
    {
        "name": "Jess Wu",
        "gender": "male"
    },
    {
        "name": "Riley Martin",
        "gender": "male"
    },
    {
        "name": "Mac Potter",
        "gender": "male"
    },
    {
        "name": "Russ Boyer",
        "gender": "male"
    },
    {
        "name": "Daron Lopez",
        "gender": "male"
    },
    {
        "name": "Jim Brady",
        "gender": "male"
    },
    {
        "name": "Donald Cook",
        "gender": "male"
    },
    {
        "name": "Arnulfo Fisher",
        "gender": "male"
    },
    {
        "name": "Young Peck",
        "gender": "male"
    },
    {
        "name": "Markus Woods",
        "gender": "male"
    },
    {
        "name": "Jeffry Roberts",
        "gender": "male"
    },
    {
        "name": "Emilio Walter",
        "gender": "male"
    },
    {
        "name": "Lanny Marshall",
        "gender": "male"
    },
    {
        "name": "Josue Vega",
        "gender": "male"
    },
    {
        "name": "Carol Shaffer",
        "gender": "male"
    },
    {
        "name": "Devon Carrillo",
        "gender": "male"
    },
    {
        "name": "Wes Sweeney",
        "gender": "male"
    },
    {
        "name": "Houston Hart",
        "gender": "male"
    },
    {
        "name": "Pedro Johnston",
        "gender": "male"
    },
    {
        "name": "Brant Hanson",
        "gender": "male"
    },
    {
        "name": "Eric Hooper",
        "gender": "male"
    },
    {
        "name": "Serena Farmer",
        "gender": "female"
    },
    {
        "name": "Lucille Abbott",
        "gender": "female"
    },
    {
        "name": "Frieda Frey",
        "gender": "female"
    },
    {
        "name": "Vicky Olsen",
        "gender": "female"
    },
    {
        "name": "Neva Cabrera",
        "gender": "female"
    },
    {
        "name": "Rochelle Frost",
        "gender": "female"
    },
    {
        "name": "Amanda Costa",
        "gender": "female"
    },
    {
        "name": "Lucia Koch",
        "gender": "female"
    },
    {
        "name": "Lavonne Lamb",
        "gender": "female"
    },
    {
        "name": "Tracie Haas",
        "gender": "female"
    },
    {
        "name": "Dianna Miles",
        "gender": "female"
    },
    {
        "name": "Essie Baxter",
        "gender": "female"
    },
    {
        "name": "Kelsey Juarez",
        "gender": "female"
    },
    {
        "name": "Leanna Joseph",
        "gender": "female"
    },
    {
        "name": "Nona Key",
        "gender": "female"
    },
    {
        "name": "Jami Cross",
        "gender": "female"
    },
    {
        "name": "Margaret Bartlett",
        "gender": "female"
    },
    {
        "name": "Linda Ryan",
        "gender": "female"
    },
    {
        "name": "Letha Padilla",
        "gender": "female"
    },
    {
        "name": "Sharlene Adkins",
        "gender": "female"
    },
    {
        "name": "Delia Riggs",
        "gender": "female"
    },
    {
        "name": "Avis Daugherty",
        "gender": "female"
    },
    {
        "name": "Josefina Medina",
        "gender": "female"
    },
    {
        "name": "Sabrina Browning",
        "gender": "female"
    },
    {
        "name": "Imogene Gregory",
        "gender": "female"
    },
    {
        "name": "Tia Foster",
        "gender": "female"
    },
    {
        "name": "Teri Morton",
        "gender": "female"
    },
    {
        "name": "Kari Meadows",
        "gender": "female"
    },
    {
        "name": "Kathryn Randall",
        "gender": "female"
    },
    {
        "name": "Iris Watts",
        "gender": "female"
    },
    {
        "name": "Ramona Hensley",
        "gender": "female"
    },
    {
        "name": "Darlene Lucero",
        "gender": "female"
    },
    {
        "name": "Abby Carrillo",
        "gender": "female"
    },
    {
        "name": "Adrienne Haney",
        "gender": "female"
    },
    {
        "name": "Lorie Simpson",
        "gender": "female"
    },
    {
        "name": "Kris Zhang",
        "gender": "female"
    },
    {
        "name": "Jodie Dougherty",
        "gender": "female"
    },
    {
        "name": "Mable Wall",
        "gender": "female"
    },
    {
        "name": "Angel Holland",
        "gender": "female"
    },
    {
        "name": "Jeannine Bryant",
        "gender": "female"
    },
    {
        "name": "Ivy Ford",
        "gender": "female"
    },
    {
        "name": "Terri Bender",
        "gender": "female"
    },
    {
        "name": "Tammi Richmond",
        "gender": "female"
    },
    {
        "name": "Vicki Dunlap",
        "gender": "female"
    },
    {
        "name": "Katrina Charles",
        "gender": "female"
    },
    {
        "name": "Stacey Mccormick",
        "gender": "female"
    },
    {
        "name": "Carrie Benton",
        "gender": "female"
    },
    {
        "name": "Deidre Arnold",
        "gender": "female"
    },
    {
        "name": "Ophelia Douglas",
        "gender": "female"
    },
    {
        "name": "Selma Tapia",
        "gender": "female"
    },
]